import { createContext } from 'react';
import type { User as FirebaseUser } from 'firebase/auth';
import type { UserDoc } from '../../shared/types/users';
import type { RoleDoc } from '../../shared/types/roles';
import type { SessionSlot } from './session';

export type AuthStatus = 'loading' | 'signed-in' | 'signed-out';

export type SessionState = 'checking' | 'ok' | 'conflict' | 'displaced' | 'error';

export type AuthContextValue = {
  status: AuthStatus;
  currentUser: FirebaseUser | null;
  userDoc: UserDoc | null;
  role: RoleDoc | null;
  userDocLoaded: boolean;
  signIn: (email: string, password: string) => Promise<void>;
  signOut: () => Promise<void>;
  /** P92 — vaga de sessão. Só 'ok' libera a árvore autenticada. */
  session: SessionState;
  sessionConflict: { slot: SessionSlot; since: number } | null;
  resolveSessionConflict: (takeOver: boolean) => Promise<void>;
  retrySession: () => Promise<void>;
  /** Reivindica a vaga de novo com o token atual (após reauth, que renova o auth_time). */
  reclaimSession: () => Promise<void>;
};

export const AuthContext = createContext<AuthContextValue | null>(null);
